import { render, staticRenderFns } from "./ProductPricingTable.vue?vue&type=template&id=56f6e882&scoped=true"
import script from "./ProductPricingTable.vue?vue&type=script&lang=js"
export * from "./ProductPricingTable.vue?vue&type=script&lang=js"
import style0 from "./ProductPricingTable.vue?vue&type=style&index=0&id=56f6e882&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f6e882",
  null
  
)

export default component.exports